import React, {useCallback, useEffect, useState} from 'react';
import ClientMemberList from "../ClientMemberList";
import {
    addClient as addClientAction,
    updateClient as updateClientAction,
    updateMemberList as updateMemberListAction
} from "../../../../../../services/company/action";
import {confirmActionRequested} from "../../../../../../services/confirmAction/action";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {getSkills, updateMemberList as updateMemberListApi} from "../../../../../../services/company/api";
import {getMemberRoleId} from "../../../../../../utils/General";
import config from "../../../../../../config";

const Members = ({client, user, company, updateMemberList}) => {

    const [skills, setSkills] = useState();

    useEffect(() => {
        getSkills(client.id).then((data) => {
            setSkills(data);
        });
    }, [client.id]);

    const addMembersToClient = useCallback((members, client) => {
        const updateData = members.map((member) => {
            const subs = member.subCompanyIds.includes(client.id) ? [...member.subCompanyIds] : [...member.subCompanyIds, client.id];
            return {
                id: member.id,
                subCompanyIds: subs,
            };
        });
        return updateMemberListApi(updateData).then(() => {
            updateMemberList(updateData);
        });
    }, [updateMemberList]);

    const removeMembersFromClient = useCallback((members, client) => {
        const updateData = members.map((member) => {
            const subs = member.subCompanyIds.filter(id => id !== client.id);
            return {
                id: member.id,
                subCompanyIds: subs,
            };
        });
        return updateMemberListApi(updateData).then(() => {
            updateMemberList(updateData);
        });
    }, [updateMemberList]);

    const agentMembers = company.members
        .filter(member => getMemberRoleId(member) === config.rolesMap.agent)
        .filter(member => member.status === config.statusMap.enabled);

    const {tariff} = company;

    if (!client) return null

    return (
        <div>
            {skills && (
                <ClientMemberList
                    skills={skills}
                    client={client}
                    members={agentMembers}
                    addMembersToClient={addMembersToClient}
                    removeMembersFromClient={removeMembersFromClient}
                    tariff={tariff}
                    user={user}
                />
            )}
        </div>
    );
};

Members.propTypes = {
    client: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
    addNotification: PropTypes.func,
    confirmAction: PropTypes.func.isRequired,
    addClient: PropTypes.func.isRequired,
    updateClientAction: PropTypes.func.isRequired,
    updateMemberList: PropTypes.func.isRequired,
    commonStyles: PropTypes.shape({
        wrapper: PropTypes.object,
        title: PropTypes.object,
    }),
    user: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    company: state.company,
    user: state.user,
});

const mapDispatchToProps = dispatch => ({
    addClient: (newClient) => {
        dispatch(addClientAction(newClient));
    },
    confirmAction: (func, args) => {
        dispatch(confirmActionRequested(func, args));
    },
    updateMemberList: (membersUpdate) => {
        dispatch(updateMemberListAction(membersUpdate));
    },
    updateClientAction: (clientId, update) => {
        dispatch(updateClientAction(clientId, update));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Members);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/Members.jsx